import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/AutofillByZip'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class AutofillByZipStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "AutofillByZipStore",
			variables: true,
		})
	}
}

export async function load_AutofillByZip(params) {
  await initClient()

	const store = new AutofillByZipStore()

	await store.fetch(params)

	return {
		AutofillByZip: store,
	}
}
